<template>
  <div>
    <Head :title="__('Services')" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />
      <Link class="btn-indigo" :href="route('services.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Description') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Customers') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Active') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Created') }}</th>
        </tr>
        <tr v-for="service in services.data" :key="service.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('services.edit', service.id)">
              {{ service.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center" :href="route('services.edit', service.id)" tabindex="-1">
              {{ service.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center" :href="route('services.edit', service.id)" tabindex="-1">
              {{ service.users_count }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center" :href="route('services.edit', service.id)" tabindex="-1">
              <span :class="service.active ? 'text-green-600 font-semibold' : 'text-red-500'">
                {{ service.active ? __('Yes') : __('No') }}
              </span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center" :href="route('services.edit', service.id)" tabindex="-1">
              {{ service.created_at }}
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="route('services.edit', service.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="services.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">{{ __('No services found.') }}</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="services.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  name: 'ServiceIndex',
  components: { Head, Icon, Link, Pagination, SearchInput },
  layout: Layout,
  props: {
    filters: Object,
    services: Object,
    title: String,
  },
  data() {
    return {
      form: { search: this.filters.search },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('manage.services'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
